import { Tab, Tabs } from "react-bootstrap";
import { useState } from "react";
import icon from "../../../assets/static/images/secciones/bandejaentrada.png";
import XlsGeneratorHome from "./Components/CrearExcel";
import TitleGeneratorHome from "./Components/CrearTitulos";
import ChargeRegProp from "./Components/CargarRegistros";
import ListTitleHome from "./Components/ListadoTitulosCreados";

const CreacionTitulos = () => {
  const [key, setKey] = useState("inicio");

  const handleKey = (e) => {
    setKey(e);
  };

  return (
    <div className="section-content inbox-section mesa-judicial">
      <div className="section-title d-flex align-items-center">
        <img src={icon} alt="bandejaentrada" />
        <span>Creación de Títulos</span>
      </div>
      <Tabs
        activeKey={key}
        onSelect={handleKey}
        className="w-full mt-5"
      >
        <Tab eventKey="inicio" title="1 - Crear Excel">
          <XlsGeneratorHome />
        </Tab>
        <Tab eventKey="crearTitulos" title="2 - Crear Títulos">
          <TitleGeneratorHome />
        </Tab>
        {/* Ver si esto lo dejo así o lo cambio de alguna forma */}
        <Tab eventKey="ListadoTitulosCreados" title="Listado Títulos Creados">
          {
            key === "ListadoTitulosCreados" 
              ? <ListTitleHome />
              : null
          }
        </Tab>
        <Tab eventKey="CargarRegistros" title="Cargar Registros Inmueble Prov">
          <ChargeRegProp />
        </Tab>
      </Tabs>
    </div>
  );
};


export default CreacionTitulos;